import { render, staticRenderFns } from "./SAccProjects.vue?vue&type=template&id=052c71b0&scoped=true"
import script from "./SAccProjects.vue?vue&type=script&lang=ts"
export * from "./SAccProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052c71b0",
  null
  
)

export default component.exports